module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab10/awsop-lab10.component.css
// module id = ./src/app/course/labs/awsop/awsop-lab10/awsop-lab10.component.css
// module chunks = main